import OButton from 'components/reusable/OButton';
import OInputField from 'components/reusable/OInputField';
import useToastContext from 'hooks/useToastContext';
import { isEmpty } from 'lodash';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { apiPost } from 'utils/apiFetch';
import apiPath from 'utils/apiPath';
import { validationRules } from 'utils/constants';

const ResetPasswordModal = ({ setResetPasswordModal, item }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const notification = useToastContext();

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, isDirty },
  } = useForm({
    mode: 'onChange',
    shouldFocusError: true,
  });

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const path = apiPath.agentResetPassword;
      const result = await apiPost(path + '/' + item?._id, data);

      if (result?.data?.success) {
        setResetPasswordModal(false);
        notification.success(result.data.message);
      } else {
        setResetPasswordModal(false);
        notification.error(result.data.message);
      }
    } catch (error) {
      console.error(error.message);
    }
    setLoading(false);
  };
  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative my-6  w-full max-w-[700px] mx-auto">
          <div className="sm:py-4 sm:px-2 py-8 px-7">
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
              <div className="flex items-center justify-between p-5  border-b border-solid border-slate-200 rounded-t">
                <h3 className="text-xl truncate font-semibold">
                  {t('O_RESET_PASSWORD')}
                </h3>
                <button
                  className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none"
                  onClick={() => setResetPasswordModal(false)}
                >
                  <span className=" text-[#B8BBBF]  text-4xl " title="Close">
                    ×
                  </span>
                </button>
              </div>
              <div className="relative p-6 flex-auto">
                <div className="grid grid-cols-1 gap-3">
                  <OInputField
                    wrapperClassName="relative z-0  w-full group"
                    name="newPassword"
                    inputLabel={
                      <>
                        {t('O_NEW_PASSWORD')}
                        <span className="text-red-500">*</span>
                      </>
                    }
                    type="password"
                    autoFocus
                    register={register('newPassword', {
                      required: {
                        value: true,
                        message: 'Please enter your new password.',
                      },
                      pattern: {
                        value: validationRules.password,
                        message:
                          'Password must include at least one uppercase letter, one lowercase letter, one number, and one special character.',
                      },
                      minLength: {
                        value: 8,
                        message: 'Password must be at least 8 characters long.',
                      },
                    })}
                    errors={errors}
                  />

                  <OInputField
                    wrapperClassName="relative z-0 w-full group"
                    name="confirmPassword"
                    inputLabel={
                      <>
                        {t('O_CONFIRM_PASSWORD')}
                        <span className="text-red-500">*</span>
                      </>
                    }
                    type="password"
                    autoFocus
                    disabled={isEmpty(watch('newPassword'))}
                    register={register('confirmPassword', {
                      required: {
                        value: true,
                        message: 'Please confirm your password.',
                      },
                      validate: (value) =>
                        value === watch('newPassword') ||
                        'Passwords do not match.',
                    })}
                    errors={errors}
                  />

                  <OButton
                    extraClasses="w-full lg:w-2/3 md:w-2/3 mt-4"
                    disabled={!isDirty || loading}
                    label={<>{t('O_SUBMIT')}</>}
                    type="submit"
                    onClick={handleSubmit(onSubmit)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black" />
    </>
  );
};

export default ResetPasswordModal;
